﻿import { analyticsEvent } from '../../controllers/analytics-controller';
var AdvanceSearchController = function ($rootScope, $location, searchService, searchBootstrapper) {
  "use strict";
  var vm = this;
  vm.searchService = searchService;
  vm.searchBootstrapper = searchBootstrapper;
  vm.location = $location;
  vm.headlinesOnly = null;
  vm.entitledContentOnly = null;
  vm.exactMatchOnly = null;
  vm.searchParams = vm.location.search();
  vm.routerBuilder = vm.searchService.getRouteBuilder();
  vm.searchInput = document.getElementById("js-search-field");

  if(vm.searchParams) {
    _.forIn(vm.searchParams, function(value, key) {
      switch (key) {
        case 'headlinesOnly':
          vm.headlinesOnly = true;
          break;
        case 'entitledcontentonly':
          vm.entitledContentOnly = true;
          break;
        case 'exactmatchonly':
          vm.exactMatchOnly = true;
          break;
        default:
          return true;
      }
    });
  }

  vm.update = function () {
    var newParams = vm.location.search(),
        filterQuery = vm.searchService.getFilter('q')._value,
        newSearchInput = document.getElementById("js-search-field").value;
        
    if(vm.headlinesOnly) {
      vm.searchBootstrapper.createFilter('headlinesOnly', '1');
    } else {
      vm.searchBootstrapper.createFilter('headlinesOnly', '');
    }
    if(vm.entitledContentOnly){
      vm.searchBootstrapper.createFilter('entitledcontentonly', '1');
    } else {
      vm.searchBootstrapper.createFilter('entitledcontentonly', '');
    }
    if(vm.exactMatchOnly){
      if(filterQuery && filterQuery[0] !== '"' && filterQuery[filterQuery.length - 1] !== '"') {
        vm.searchBootstrapper.createFilter('q', '"' + newParams.q + '"');
        vm.searchInput.value = '"' + newParams.q + '"';
      }
      vm.searchBootstrapper.createFilter('exactmatchonly', '1');
    } else {
      if(filterQuery && filterQuery[0] === '"' && filterQuery[filterQuery.length - 1] === '"') {
        vm.searchBootstrapper.createFilter('q', newParams.q.replace(/['"]+/g, ''));
        vm.searchInput.value = newParams.q.replace(/['"]+/g, '');
      }
      vm.searchBootstrapper.createFilter('exactmatchonly', '');
    }
    if(newSearchInput && newSearchInput !== newParams.q) {
      if(vm.exactMatchOnly && newSearchInput[0] !== '"' && newSearchInput[newSearchInput.length - 1] !== '"') {
        vm.searchBootstrapper.createFilter('q', '"' + newSearchInput + '"');
        vm.searchInput.value = '"' + newSearchInput + '"';
        vm.searchBootstrapper.createFilter('exactmatchonly', '1');
        vm.exactMatchOnly = true;
      } else if(!vm.exactMatchOnly && newSearchInput[0] === '"' && newSearchInput[newSearchInput.length - 1] === '"') {
        vm.searchBootstrapper.createFilter('q', newSearchInput.replace(/['"]+/g, ''));
        vm.searchInput.value = newSearchInput.replace(/['"]+/g, '');
        vm.searchBootstrapper.createFilter('exactmatchonly', '');
      } else {
        vm.searchBootstrapper.createFilter('q', newSearchInput);
        vm.searchInput.value = newSearchInput;
        vm.searchBootstrapper.createFilter('exactmatchonly', '');
        vm.exactMatchOnly = false;
      }
    }
    
    vm.searchBootstrapper.createFilter('contenttype', newParams.contenttype);
    var routerBuilder = vm.searchService.getRouteBuilder();
    vm.location.search(routerBuilder.getRoute());
    vm.searchService.query();
  };  

};
var informaSearchApp = angular.module('informaSearchApp');
informaSearchApp.controller("AdvanceSearchController", ['$rootScope', '$location', 'searchService', 'searchBootstrapper', AdvanceSearchController]);
